// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { SystemDocument } from '@interfaces/document.interfaces';
import { UserService } from '@services/user.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SystemDocumentsResolver implements Resolve<SystemDocument[]> {
    constructor(private userService: UserService) {}

    resolve(): Observable<SystemDocument[]> {
        return this.userService.getRequiredSystemDocuments();
    }
}
